import React, {
  FC,
  createContext,
  useReducer,
  useContext,
  Reducer,
  Dispatch,
} from 'react';

interface IAction<ActionType> {
  type: ActionType;
  payload?: any;
}

export const createAction = <Type, Payload>(
  type: Type,
  payload?: Payload
): IAction<Type> => {
  return { type, payload };
};

const generateContext = <State, Action>(
  reducer: Reducer<State, Action>,
  initialState: State
): [FC<{}>, () => State, () => Dispatch<Action>] => {
  const stateContext = createContext<State>(initialState);
  const dispatchContext = createContext<Dispatch<Action>>(() => {});

  const ContextProvider: FC = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
      <dispatchContext.Provider value={dispatch}>
        <stateContext.Provider value={state}>{children}</stateContext.Provider>
      </dispatchContext.Provider>
    );
  };

  const useContextState = () => {
    return useContext(stateContext);
  };

  const useContextDispatch = () => {
    return useContext(dispatchContext);
  };

  return [ContextProvider, useContextState, useContextDispatch];
};

export default generateContext;
